// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","menu_button":"Header_menu_button__jLf-2","nav":"Header_nav__IIF23"};